import type { MatchLiveViewers } from '@aiscoreboard/contracts';
import { useLocale } from '../lib/i18n';

export function LiveViewerCount({ data }: { data: MatchLiveViewers | null }) {
  const { t, locale } = useLocale();
  if (!data || data.status === 'offline') return null;
  const available = data.status === 'unavailable'
    || (data.status === 'available' && data.concurrentViewers !== null);
  const label = t('youtube.viewers', {
    n: data.status === 'available' && data.concurrentViewers !== null
      ? new Intl.NumberFormat(locale).format(data.concurrentViewers) : data.status === 'unavailable' ? '0' : '—',
  });
  const hint = t(data.status === 'error' ? 'youtube.viewersError' : 'youtube.viewersHint');
  return (
    <span
      data-live-viewers
      role="status"
      title={hint}
      aria-label={`${label}. ${hint}`}
      className="inline-flex items-center gap-1.5 whitespace-nowrap tabular-nums text-red-400"
    >
      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${available ? 'bg-red-400' : 'bg-white/35'}`} aria-hidden="true" />
      {label}
    </span>
  );
}
